function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#596266",
  d: "M7.29938328,10.1148303 L6.02509141,14 L5.32774095,12.0864726 L3.70710678,13.7071068 L3,13 L14,2 L14.7071068,2.70710678 L10.9899417,6.42427191 L11.9415294,8.45516917 L12.6396204,6.53960971 L16,6.53960971 L16,7.45427529 L13.3603796,7.45427529 L12.0584706,11.0267093 L10.2490996,7.16511399 L7.29938328,10.1148303 Z M5.34958027,9.25397312 L4.57702978,10.0265236 L3.63962039,7.45427529 L0,7.45427529 L0,6.53960971 L4.36037961,6.53960971 L5.34958027,9.25397312 Z M7.11759199,7.4859614 L8.91692549,2 L10.0931761,4.51037727 L9.35233404,5.25121935 L9.08307451,4.67656036 L8.67118297,5.93237042 L7.11759199,7.4859614 Z"
});

var SvgDisconnected = function SvgDisconnected(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDisconnected, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Disconnected.ca957631.svg";
export { ForwardRef as ReactComponent };